import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { BillOfLadingService } from 'common/data';

class BillOfLadingStore extends BaseStore {
	constructor(rootStore) {
		super(new BillOfLadingService(rootStore.app.baasic.apiClient));
	}

	@action
	async print(id) {
		const response = await this.service.print(id);
		this.response = response.data;
		return this.response;
	}

	@action
	async pull(id) {
		const response = await this.service.pull(id);
		this.response = response.data;
		return this.response;
	}

	@action
	async acquire(id, source) {
		const response = await this.service.acquire(id, source);
		this.response = response.data;
		return this.response;
	}

	@action
	upload = async (id, data) => {
		const response = await this.service.upload(id, data);
		this.item = response;
		return this.item.data;
	};

	@action
	void = async (id, data) => {
		const response = await this.service.void(id, data);
		this.item = response;
		return this.item.data;
	};

	@action
	pullBulk = async (ids) => {
		const response = await this.service.pullBulk(ids);
		this.item = response;
		return this.item.data;
	}
}

export default BillOfLadingStore;
